import { withBlockExtensions } from '@plone/volto/helpers';
import cx from 'classnames';

const HeroHeadingView = (props) => {
  const { className, data } = props;
  if (!data) return null;
  const title = data.title;
  if (!title) return null;

  return (
    <section className={cx('item', 'junts-hero-heading', className)}>
      <h1>{data.title}</h1>
    </section>
  );
};

export default withBlockExtensions(HeroHeadingView);
